const normalizeOrigin = (value, fallback) => {
  let v = String(value || fallback || "").trim().replace(/\/+$/, "");
  if (!v) return fallback;
  if (!/^https?:\/\//i.test(v)) v = `https://${v}`;
  return v;
};

const isLocalDev =
  typeof window !== "undefined" && window.location.hostname === "localhost";

export const getTawanSpaPublicUrl = () =>
  normalizeOrigin(
    process.env.REACT_APP_TAWAN_SPA_URL,
    isLocalDev ? "http://localhost:3000" : "https://tawan-spa.com"
  );

export const getDrHoffmannPublicUrl = () =>
  normalizeOrigin(
    process.env.REACT_APP_PUBLIC_URL,
    typeof window !== "undefined" ? window.location.origin : "https://dr-hoffmann-massage.de"
  );
